export default "__VITE_ASSET__Dnxz_N74__"